import { call, put, takeLatest } from 'typed-redux-saga';
import { logError } from '../../../../utils/log';
import { refreshUserInfo } from '../../../containers/UserLogin/saga';
import { getApiErrorMessage } from '../../../services/ApiClient';
import { managerService } from '../../../services/Manager/manager.service';
import { myAccountNotifications } from '../notification';
import { userAccountPageActions } from './userAccount.slice';

function* submitManager(action: ReturnType<typeof userAccountPageActions.submitManager>) {
    try {
        yield* put(userAccountPageActions.setLoading(true));
        yield* call(managerService.updateManager, action.payload);
        yield* call(refreshUserInfo);
        yield* put(myAccountNotifications.updatedSuccessfully);
    }
    catch (error) {
        logError({
            error,
            target: 'UserAccountPage.submitManager',
        });
        const message = getApiErrorMessage(error);
        yield* put(myAccountNotifications.unknownError(message));
    }
    finally {
        yield* put(userAccountPageActions.setLoading(false));
    }
}

export function* submitManagerSaga() {
    yield* takeLatest(userAccountPageActions.submitManager, submitManager);
}
